const typeCollaborationConstant = {
  WITH_UNLIMITED_PERMANENT_PERCENT: 1,
  WITH_LIMITED_PERMANENT_PERCENT: 2,
  WITHOUT_PERMANENT_PERCENT: 3,
};

const getTypeCollaborationString = () => {
  let data = {};

  data[typeCollaborationConstant.WITH_UNLIMITED_PERMANENT_PERCENT] =
    "با درصد دائمی نامحدود";
  data[typeCollaborationConstant.WITH_LIMITED_PERMANENT_PERCENT] =
    "با درصد دائمی محدود";
  data[typeCollaborationConstant.WITHOUT_PERMANENT_PERCENT] = "بدون درصد دائمی";

  return data;
};

export default {
  typeCollaborationConstant,
  getTypeCollaborationString,
};
